import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  ButtonsModule,
  ColorModule,
  InputModule,
  PaginationMapsModule,
} from "maps-angular-components";
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig } from "ng2-currency-mask";
import {
  BsDatepickerConfig,
  BsLocaleService,
  PaginationConfig,
  PaginationModule,
  TabsModule,
  TooltipConfig,
} from "ngx-bootstrap";

import { registerLocaleData } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import localePt from "@angular/common/locales/pt";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTabsModule } from "@angular/material/tabs";
import { BrowserModule } from "@angular/platform-browser";
import { OAuthModule } from 'angular-oauth2-oidc';
import { NgStringPipesModule } from "ngx-pipes";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AssociacaoModule } from "./associacao/associacao.module";
import { CarteiraModule } from "./carteira/carteira.module";
import { DashboardModule } from "./dashboard/dashboard.module";
import { FeitoConferidoModule } from "./feito-conferido/feito-conferido.module";
import { GuardsModule } from "./guards/guards.module";
import { HomeComponent } from "./home/home.component";
import { HomeModule } from "./home/home.module";
import { ProcessamentoModule } from "./processamento/processamento.module";
import { RegraModule } from "./regra/regra.module";
import { ResultadoRegraModule } from "./resultado-regra/resultado-regra.module";
import { SideMenuModule } from "./shared/layout/sidemenu/sidemenu.module";
import { SharedModule } from "./shared/shared.module";
import { TrilhaAuditoriaModule } from "./trilha-auditoria/trilha-auditoria.module";
import {GrupoCarteiraModule} from "./grupo-carteira/grupo-carteira.module";
import {AssociacaoGrupoCarteiraModule} from "./associacao-grupo-carteira/associacao-grupo-carteira.module";
import { HistoricoModule } from "./relatorio-historico/historico.module";

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  decimal: ",",
  precision: 2,
  prefix: "",
  suffix: "",
  thousands: ".",
};

registerLocaleData(localePt);
@NgModule({
  declarations: [AppComponent, HomeComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ButtonsModule,
    FormsModule,
    HttpClientModule,
    MatButtonModule,
    ColorModule,
    GuardsModule,
    SharedModule,
    MatDialogModule,
    SideMenuModule,
    InputModule,
    HomeModule,
    ReactiveFormsModule,
    ResultadoRegraModule,
    HistoricoModule,
    CarteiraModule,
    GrupoCarteiraModule,
    AssociacaoGrupoCarteiraModule,
    FeitoConferidoModule,
    TrilhaAuditoriaModule,
    ProcessamentoModule,
    AssociacaoModule,
    RegraModule,
    NgStringPipesModule,
    PaginationMapsModule,
    PaginationModule,
    DashboardModule,
    TabsModule,
    MatTabsModule,
    OAuthModule.forRoot({
      resourceServer: {
          allowedUrls: ['/enquadramento/ui/security.json'],
          sendAccessToken: true
      }
    })
  ],
  providers: [
    // {provide: LocationStrategy, useClass: HashLocationStrategy},
    BsLocaleService,
    BsDatepickerConfig,
    TooltipConfig,
    PaginationConfig,
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
